import { useEffect } from "react";

/** AquaFitX Race look, shared by its display board and start list. */
export const AQUAFITX_GOLD = "#F6B800";
export const AQUAFITX_NAVY = "#041036";
export const AQUAFITX_FONT = "'Saira Condensed', 'Oxanium', sans-serif";
export const AQUAFITX_BG =
  "linear-gradient(rgba(3,10,40,0.35), rgba(3,10,40,0.55)), url(/aquafitx/bg.jpg)";

/** Loads the condensed display face the event's key visual is set in. */
export const useAquaFitXFont = () => {
  useEffect(() => {
    const id = "aquafitx-font";
    if (document.getElementById(id)) return;
    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=Saira+Condensed:wght@500;600;700;800;900&display=swap";
    document.head.appendChild(link);
  }, []);
};
